import { type ReactNode, type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { FormInstance, Popconfirm } from 'antd';

import { NoteType, type WithOptionalDataTest } from 'types';
import { Select, Textarea } from '@g2u/ui-kit';
import styles from '../tickets.module.scss';

type Props = {
  title: string;
  form: FormInstance;
  onConfirm: () => void;
  children: ReactNode;
  noteTypes?: NoteType[];
  isFormValid?: boolean;
} & WithOptionalDataTest;

export const AddNotePopconfirm: FC<Props> = observer((props) => {
  const { onConfirm, children, form, noteTypes, isFormValid, title } = props;

  return (
    <Popconfirm
      key="add"
      title={title}
      icon={null}
      onConfirm={onConfirm}
      onOpenChange={() => form.resetFields()}
      description={
        <div className={styles.tickets__detailsAddNotes}>
          <Textarea.$
            name="newNote"
            placeholder="Text area"
            style={{ width: 276, minHeight: 150, maxHeight: 150, marginBottom: 0 }}
            rules={[{ required: true, message: 'Provide a note' }]}
          />
          <Select.$
            name={'noteType'}
            label="Note type"
            popupMatchSelectWidth={false}
            colon
            required
            rules={[{ required: true }]}
            fullWidth
            options={[
              ...(noteTypes ?? []).map((type) => ({
                label: type?.desc,
                value: type?.ID?.toString(),
              })),
            ]}
          />
        </div>
      }
      okButtonProps={{ disabled: !isFormValid }}
      okText="Save"
    >
      <div>{children}</div>
    </Popconfirm>
  );
});
